import React, { useContext, useState, useEffect, useMemo } from "react";
import { TextInput, Label, Modal } from "flowbite-react";
import Swal from "sweetalert2";
import axios from "axios";
import DataTable from "react-data-table-component";
import Select from "react-select";
import GlobalContext from "../connections/GlobalContext";
import engineGif from "../image/engine.gif";
import Head_data from "../components/Head_data";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { PencilSquareIcon } from "@heroicons/react/24/solid";

const formatCurrency = (amount) => {
    const numAmount = typeof amount === "number" ? amount : parseFloat(amount);
    if (isNaN(numAmount)) {
        return "₹0.00";
    }
    let formatted = new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(numAmount);
    return formatted.replace("₹", "₹");
};


const Payment = ({ theme }) => {
    const { globalValue } = useContext(GlobalContext);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({ sales: { cash: [], credit: [] }, service: { cash: [], credit: [] } });

    const [mainTab, setMainTab] = useState('sales');
    const [subTab, setSubTab] = useState('cash');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [paymentAmount, setPaymentAmount] = useState("");
    const [paymentError, setPaymentError] = useState("");

    const [paymentError1, setPaymentError1] = useState("");
    const [payment_from, setPayment_from] = useState("");
    const [payment_type, setPaymentType] = useState("");

    const [isLogModalOpen, setIsLogModalOpen] = useState(false);
    const [customerName, setCustomerName] = useState("");
    const [logData, setLogData] = useState([]);
    const [selectedLogBillNo, setSelectedLogBillNo] = useState(null);
    const [discount, setDiscount] = useState(0);
    const [advanceAmount, setAdvanceAmount] = useState(0);

    const [searchTerm, setSearchTerm] = useState("");
    const [temp_data, setTemp_data] = useState(null);
    const [temp_total, setTemp_total] = useState(0);
    const [filterStartDate, setFilterStartDate] = useState("");
    const [filterEndDate, setFilterEndDate] = useState("");
    const [filterPaymentType, setFilterPaymentType] = useState("");
    const [filterResult, setFilterResult] = useState(null);
    const [showFilterModal, setShowFilterModal] = useState(false);
    const [filterIncludeMode, setFilterIncludeMode] = useState(true);
    const [filterIncludeBillType, setFilterIncludeBillType] = useState(true);

    // ── Pending Report state ───────────────────────────────────────────────────
    // Shares filterStartDate, filterEndDate, filterIncludeMode, filterIncludeBillType
    const [showPendingModal, setShowPendingModal] = useState(false);
    const [pendingReportData, setPendingReportData] = useState([]);
    const [customers, setCustomers] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    // ──────────────────────────────────────────────────────────────────────────

    const [date, setDate] = useState(() => {
        const today = new Date();
        return today.toISOString().split("T")[0];
    });

    const customStyles = {
        table: {
            style: {
                backgroundColor: theme === "dark" ? "rgb(31, 41, 55)" : "white",
                width: "100%",
                border: theme === "dark" ? "solid 1px rgb(63, 62, 62)" : "solid 1px rgb(226, 232, 240)",
                borderRadius: "8px",
                overflow: "hidden",
                boxShadow: theme === "dark" ? "0 4px 6px rgba(0, 0, 0, 0.3)" : "0 4px 6px rgba(0, 0, 0, 0.1)",
            },
        },
        headCells: {
            style: {
                backgroundColor: theme === "dark" ? "rgb(55, 65, 81)" : "rgb(226, 232, 240)",
                color: theme === "dark" ? "white" : "black",
                fontWeight: "bold",
                fontSize: '14px',
                padding: '12px 16px',
                borderBottom: "none",
            },
        },
        cells: {
            style: {
                color: theme === "dark" ? "white" : "black",
                backgroundColor: theme === "dark" ? "rgb(31, 41, 55)" : "white",
                border: theme === "dark" ? "solid 1px rgb(63, 62, 62)" : "solid 1px rgb(255, 255, 255)",
                padding: '10px 16px',
            },
        },
        pagination: {
            style: {
                backgroundColor: theme === "dark" ? "rgb(31, 41, 55)" : "white",
                color: theme === "dark" ? "white" : "black",
                borderTop: theme === "dark" ? "solid 1px white" : "solid 1px rgb(226, 232, 240)",
                padding: '10px 16px',
            },
            pageButtonsStyle: {
                backgroundColor: theme === "dark" ? "rgb(31, 41, 55)" : "white",
                color: theme === "dark" ? "white" : "black",
                fill: theme === "dark" ? "white" : "black",
                '&:hover': {
                    backgroundColor: theme === "dark" ? "rgb(55, 65, 81)" : "rgb(226, 232, 240)",
                },
                '&:focus-visible': {
                    outline: 'none',
                    boxShadow: '0 0 0 2px rgba(99, 102, 241, 0.5)',
                }
            },
        },
    };

    const [editingIndex, setEditingIndex] = useState(null);
    const [editForm, setEditForm] = useState({ id: "", amount: "", discount: "" });

    const handleEditClick = (log, index) => {
        setEditingIndex(index);
        setEditForm({
            id: log[0],
            amount: log[2],
            discount: log[5],
        });
    };

    const getSumsExcludingIndex = (excludeIndex) => {
        let otherAmt = 0;
        let otherDisc = 0;
        logData.forEach((log, i) => {
            if (i !== excludeIndex) {
                otherAmt += parseFloat(log[2]) || 0;
                otherDisc += parseFloat(log[5]) || 0;
            }
        });
        return { otherAmt, otherDisc };
    };

    const onChangeAmount = (value) => {
        const proposedAmount = parseFloat(value || 0) || 0;
        const { otherAmt, otherDisc } = getSumsExcludingIndex(editingIndex);
        const currentDiscount = parseFloat(editForm.discount || 0) || 0;

        // Check if the current entry is of type 'advance'
        const currentLogEntry = logData[editingIndex];
        const isAdvanceType = currentLogEntry && currentLogEntry[3] === "advance";

        if (isAdvanceType) {
            const currentAmountInLog = parseFloat(currentLogEntry[2]) || 0;
            const maxAllowedForAdvance = advanceAmount + currentAmountInLog;

            if (proposedAmount > maxAllowedForAdvance) {
                Swal.fire({
                    icon: "warning",
                    title: "Exceeded Advance Balance",
                    text: `This amount exceeds the available advance balance (${formatCurrency(advanceAmount)} + current ${formatCurrency(currentAmountInLog)}). Maximum allowed is ${formatCurrency(maxAllowedForAdvance)}.`,
                });
                setEditForm({ ...editForm, amount: maxAllowedForAdvance.toFixed(2).toString() });
                return;
            }
        }

        const proposedGrandTotal = otherAmt + proposedAmount + otherDisc + currentDiscount;
        if (proposedGrandTotal > temp_total && temp_total > 0) {
            const maxAllowed = Math.max(0, temp_total - otherAmt - otherDisc - currentDiscount);
            Swal.fire({
                icon: "warning",
                title: "Exceeded total",
                text: `This change would make totals exceed allowed main total (${formatCurrency(temp_total)}). Maximum allowed for this amount is ${formatCurrency(maxAllowed)}.`,
            });
            setEditForm({ ...editForm, amount: maxAllowed.toFixed(2).toString() });
            return;
        }
        setEditForm({ ...editForm, amount: value });
    };

    const onChangeDiscount = (value) => {
        const proposedDiscount = parseFloat(value || 0) || 0;
        const { otherAmt, otherDisc } = getSumsExcludingIndex(editingIndex);
        const currentAmount = parseFloat(editForm.amount || 0) || 0;

        const proposedGrandTotal = otherAmt + currentAmount + otherDisc + proposedDiscount;
        if (proposedGrandTotal > temp_total) {
            const maxAllowedDisc = Math.max(0, temp_total - otherAmt - otherDisc - currentAmount);
            Swal.fire({
                icon: "warning",
                title: "Exceeded total",
                text: `This discount would make totals exceed allowed main total (${formatCurrency(temp_total)}). Maximum allowed discount for this entry is ${formatCurrency(maxAllowedDisc)}.`,
            });
            setEditForm({ ...editForm, discount: maxAllowedDisc.toFixed(2).toString() });
            return;
        }
        setEditForm({ ...editForm, discount: value });
    };

    const handleUpdate = async () => {
        try {
            const newAmount = parseFloat(editForm.amount || 0) || 0;
            const newDiscount = parseFloat(editForm.discount || 0) || 0;

            const currentLogEntry = logData[editingIndex];
            const isAdvanceType = currentLogEntry && currentLogEntry[3] === "advance";

            if (isAdvanceType) {
                const currentAmountInLog = parseFloat(currentLogEntry[2]) || 0;
                const maxAllowedForAdvance = advanceAmount + currentAmountInLog;

                if (newAmount > maxAllowedForAdvance) {
                    Swal.fire({
                        icon: "warning",
                        title: "Exceeded Advance Balance",
                        text: `This update would exceed the available advance balance (${formatCurrency(advanceAmount)} + current ${formatCurrency(currentAmountInLog)}). Maximum allowed is ${formatCurrency(maxAllowedForAdvance)}.`,
                    });
                    return;
                }
            }

            let otherAmt = 0;
            let otherDisc = 0;
            logData.forEach((log, i) => {
                if (i !== editingIndex) {
                    otherAmt += parseFloat(log[2]) || 0;
                    otherDisc += parseFloat(log[5]) || 0;
                }
            });

            const finalGrandTotal = otherAmt + newAmount + otherDisc + newDiscount;
            if (finalGrandTotal > temp_total && temp_total > 0) {
                const remaining = Math.max(0, temp_total - (otherAmt + otherDisc));
                Swal.fire({
                    icon: "warning",
                    title: "Exceeded Limit",
                    text: `This update would exceed the main total (${formatCurrency(temp_total)}). You can only assign up to ${formatCurrency(remaining)} for this entry (amount + discount).`,
                });
                return;
            }

            const response = await axios.post(
                `${globalValue}/update_payment_log_record`,
                { id: editForm.id, amount: newAmount, discount: newDiscount },
                { headers: { "x-access-token": sessionStorage.getItem("token") } }
            );

            if (response.data.success === 1) {
                Swal.fire({
                    icon: "success",
                    title: "Update Successful!",
                    text: response.data.message || "Log updated successfully.",
                    timer: 2500,
                    showConfirmButton: false,
                });
                handleLogClick(temp_data);
            } else {
                Swal.fire({ icon: "error", title: "Update Failed", text: response.data.message || "Update could not be processed." });
            }

            setEditForm({ id: "", amount: "", discount: "" });
            setEditingIndex(null);
        } catch (error) {
            console.error("Update failed:", error);
            Swal.fire({ icon: "error", title: "Update Error", text: error.response?.data?.message || "Something went wrong. Please try again." });
        }
    };

    const fetchData = () => {
        setLoading(true);
        const branch = sessionStorage.getItem("branch");
        fetch(`${globalValue}/payment_display?branch=${branch}`, {
            method: "GET",
            headers: { "x-access-token": sessionStorage.getItem("token") },
        })
            .then((res) => {
                if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
                return res.json();
            })
            .then((dat) => {
                const processedData = {
                    sales: {
                        cash: dat.sales?.cash?.map(item => ({ ...item, pending: (item.amount || 0) - (item.paid || 0) })) || [],
                        credit: dat.sales?.credit?.map(item => ({ ...item, pending: (item.amount || 0) - (item.paid || 0) })) || [],
                    },
                    service: {
                        cash: dat.service?.cash?.map(item => ({ ...item, pending: (item.amount || 0) - (item.paid || 0) })) || [],
                        credit: dat.service?.credit?.map(item => ({ ...item, pending: (item.amount || 0) - (item.paid || 0) })) || [],
                    },
                };
                setData(processedData);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
                Swal.fire({ icon: 'error', title: 'Data Load Error', text: 'Failed to load payment data. Please try again later.' });
            })
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        const fetchCustomers = async () => {
            try {
                const response = await axios.get(`${globalValue}/customers`, {
                    params: {
                        data: sessionStorage.getItem("branch"),
                        position: "",
                    },
                    headers: { "x-access-token": sessionStorage.getItem("token") },
                });
                setCustomers(response.data || []);
            } catch (error) {
                console.error("Error fetching customers:", error);
            }
        };
        fetchCustomers();
        fetchData();
    }, [globalValue]);

    const customerOptions = useMemo(() => [
        { value: "", label: "All Customers" },
        ...customers.map((c) => ({
            value: c[2],
            label: `${c[2]} (${c[4]})`,
        }))
    ], [customers]);

    const [paydiscount, setPaydiscount] = useState(0);

    const handlePayClick = (row) => {
        const calculatedPending = (row.amount || 0) - (row.paid || 0);
        setSelectedRow({ ...row, pending: calculatedPending });
        setIsModalOpen(true);
        setPaymentAmount("");
        setPaymentError("");
        setBill_id(row.bill_no);
        setPaydiscount(row.total_discount || 0);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setSelectedRow(null);
        setPaymentAmount("");
        setPaymentError("");
    };

    const handlePaymentSubmit = async () => {
        const amount = parseFloat(paymentAmount);
        const currentPending = selectedRow?.pending || 0;

        if (isNaN(amount) || amount <= 0) {
            setPaymentError("Please enter a valid amount (greater than zero).");
            return;
        }
        if (amount > currentPending) {
            setPaymentError(`Amount cannot exceed the pending balance of ${formatCurrency(currentPending)}.`);
            return;
        }
        if (payment_from === "" && mainTab === "service") {
            Swal.fire({ icon: 'warning', title: 'Payment Source Required', text: 'Please select a payment source (Insurance or Customer).' });
            return;
        }
        if (payment_type === "") {
            Swal.fire({ icon: 'warning', title: 'Payment Type Required', text: 'Please select a payment type.' });
            return;
        }
        if (paymentError1) {
            Swal.fire({ icon: 'warning', title: 'Invalid Discount', text: paymentError1 });
            return;
        }

        setLoading(true);
        try {
            const response = await axios.post(`${globalValue}/pay_amount_bill`, {
                bill_no: selectedRow.id,
                amount_paid: amount,
                payment_type: payment_type,
                payment_from: payment_from,
                discount: parseFloat(discount) || 0,
                mainTab: mainTab,
                bill_id: bill_id,
                date: date,
            }, { headers: { "x-access-token": sessionStorage.getItem("token") } });

            const result = response.data;
            if (result.success === 1) {
                handleCloseModal();
                Swal.fire({
                    icon: 'success', title: 'Payment Successful!',
                    text: result.message || `${formatCurrency(amount)} paid for Invoice No: ${selectedRow.bill_no}.`,
                    timer: 2500, showConfirmButton: false,
                });
                fetchData();
            } else {
                Swal.fire({ icon: 'error', title: 'Payment Failed', text: result.message || 'Payment could not be processed.' });
            }
        } catch (error) {
            console.error("Payment failed:", error);
            Swal.fire({ icon: 'error', title: 'Payment Error', text: error.response?.data?.message || 'Something went wrong. Please try again.' });
        } finally {
            setLoading(false);
        }
    };

    const handleLogClick = async (row) => {
        setSelectedLogBillNo(row.bill_no);
        setIsLogModalOpen(true);
        try {
            const res = await axios.post(`${globalValue}/payment_details_log`, { id: row.id }, {
                headers: { "x-access-token": sessionStorage.getItem("token") }
            });
            if (res.data.success === 1) {
                setLogData(res.data.data);
                setAdvanceAmount(parseFloat(res.data.advance_amount) || 0);
            } else {
                setLogData([]);
                setAdvanceAmount(0);
                Swal.fire("Error", res.data.message, "error");
            }
            setCustomerName(row.customer_name || "");
        } catch (error) {
            console.error("Error fetching logs:", error);
            Swal.fire("Error", "Could not fetch logs", "error");
        }
    };

    const [bill_id, setBill_id] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);

    const columns = useMemo(() => [
        {
            name: "S.No",
            cell: (row, index) => (currentPage - 1) * perPage + index + 1,
            width: "70px",
            sortable: false,
        },
        { name: "Invoice No", selector: row => row.bill_no, sortable: true },
        { name: "Vehicle_no", selector: row => row.vehicle_no, sortable: true, width: '120px' },
        { name: "Customer Name", selector: row => row.customer_name, sortable: true, grow: 1 },
        { name: "Total Amount", selector: row => formatCurrency(row.amount), sortable: true },
        { name: "Paid", selector: row => formatCurrency(row.paid - row.total_discount) },
        { name: "Total Discount", selector: row => formatCurrency(row.total_discount), sortable: true },
        {
            name: "Pending",
            selector: row => formatCurrency(row.pending),
            sortable: true,
            conditionalCellStyles: [
                { when: row => row.pending > 0, style: { color: 'rgb(239, 68, 68)', fontWeight: '600' } },
                { when: row => row.pending === 0, style: { color: 'rgb(34, 197, 94)', fontWeight: '600' } },
            ]
        },
        {
            name: "Date",
            selector: row => {
                const d = new Date(row.date);
                const day = String(d.getDate()).padStart(2, "0");
                const month = String(d.getMonth() + 1).padStart(2, "0");
                const year = d.getFullYear();
                return `${day}/${month}/${year}`;
            },
            sortable: true
        },
        {
            name: "Actions",
            cell: row => (
                <div className="flex gap-2">
                    <button
                        onClick={() => handlePayClick(row)}
                        disabled={row.pending <= 0}
                        className="px-3 py-1 rounded-md text-xs font-medium bg-indigo-600 text-white hover:bg-indigo-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition duration-150 ease-in-out"
                    >
                        Pay
                    </button>
                    <button
                        onClick={() => {
                            setTemp_data(row);
                            setTemp_total(row.amount);
                            handleLogClick(row);
                        }}
                        className="px-3 py-1 rounded-md text-xs font-medium bg-gray-600 text-white hover:bg-gray-700 transition duration-150 ease-in-out"
                    >
                        Logs
                    </button>
                </div>
            ),
            width: '150px'
        },
    ], [currentPage, perPage]);

    const filteredData = (data?.[mainTab]?.[subTab] || [])
        .filter(row =>
            row.customer_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            row.bill_no?.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
            row.vehicle_no?.toString().toLowerCase().includes(searchTerm.toLowerCase())
        )
        .sort((a, b) => new Date(b.date) - new Date(a.date));

    const renderDataTable = () => (
        <DataTable
            columns={columns}
            data={filteredData}
            pagination
            paginationPerPage={perPage}
            customStyles={customStyles}
            onChangePage={page => setCurrentPage(page)}
            onChangeRowsPerPage={rows => setPerPage(rows)}
            highlightOnHover
            striped={theme !== 'dark'}
            responsive
            className="rounded-xl"
            noDataComponent={
                <div className="text-gray-500 dark:text-gray-400 py-8">
                    No records to display for this category.
                </div>
            }
        />
    );

    const handleDownloadPDF = () => {
        const doc = new jsPDF();
        doc.setFontSize(14);
        doc.text(`Payment Logs for Invoice No: ${selectedLogBillNo}`, 14, 15);
        doc.text(`Customer: ${customerName} (${temp_data["vehicle_no"]})`, 14, 22);
        doc.text(`Brand : ${temp_data["brand"]}  ||   Modal : ${temp_data["model"]}`, 14, 29);

        let head = [["Date", "Amount", "Discount", "Type"]];
        if (mainTab === "service") { head[0].push("From"); }

        const rows = logData.map((log) => {
            const row = [log[1], log[2], log[5], log[3]];
            if (mainTab === "service") { row.push(log[4]); }
            return row;
        });

        const totalAmount = logData.reduce((acc, log) => acc + (parseFloat(log[2]) || 0), 0);
        const totalDiscount = logData.reduce((acc, log) => acc + (parseFloat(log[5]) || 0), 0);
        const originalAmount = totalAmount + totalDiscount;

        autoTable(doc, {
            head: head,
            body: rows,
            startY: 32,
            styles: { fontSize: 10 },
            headStyles: { fillColor: [66, 66, 66] },
            footStyles: { fillColor: false, textColor: 0 },
            foot: [
                [
                    { content: "Totals", colSpan: 1, styles: { halign: "left", fontStyle: "bold" } },
                    { content: totalAmount.toFixed(2), styles: { halign: "left", fontStyle: "bold" } },
                    { content: totalDiscount.toFixed(2), styles: { halign: "left", fontStyle: "bold" } },
                    ...(mainTab === "service" ? [{ content: "", styles: { halign: "left" } }] : [])
                ],
                [
                    { content: "Original Amount", colSpan: 2, styles: { halign: "left", fontStyle: "bold" } },
                    { content: originalAmount.toFixed(2), colSpan: 3, styles: { halign: "left", fontStyle: "bold" } },
                    ...(mainTab === "service" ? [{ content: "", styles: { halign: "left" } }] : [])
                ]
            ],
        });

        doc.save(`PaymentLogs_${selectedLogBillNo}.pdf`);
    };

    const handleDownloadTablePDF = () => {
        const doc = new jsPDF();
        doc.setFontSize(14);
        doc.text(`${mainTab} ${subTab} Logs`, 14, 15);

        const headers = [["Invoice No", "Date", "Customer Name", "Total Amount", "Paid", "Pending"]];
        const rows = filteredData.map(row => [
            row.bill_no,
            new Date(row.date).toLocaleDateString(),
            row.customer_name,
            Number(row.amount || 0).toFixed(2),
            Number(row.paid || 0).toFixed(2),
            Number(row.pending || 0).toFixed(2),
        ]);

        const totalAmount = filteredData.reduce((s, r) => s + Number(r.amount || 0), 0);
        const totalPaid = filteredData.reduce((s, r) => s + Number(r.paid || 0), 0);
        const totalPending = filteredData.reduce((s, r) => s + Number(r.pending || 0), 0);

        autoTable(doc, {
            head: headers,
            body: rows,
            startY: 25,
            styles: { fontSize: 10, halign: "center" },
            headStyles: { fillColor: [66, 66, 66], halign: "center" },
            columnStyles: { 2: { halign: "left" } },
            foot: [[
                { content: "Grand Total", colSpan: 3, styles: { halign: "left", fontStyle: "bold" } },
                { content: totalAmount.toFixed(2), styles: { halign: "center", fontStyle: "bold" } },
                { content: totalPaid.toFixed(2), styles: { halign: "center", fontStyle: "bold" } },
                { content: totalPending.toFixed(2), styles: { halign: "center", fontStyle: "bold" } },
            ]],
        });

        doc.save(`${mainTab}_${subTab}.pdf`);
    };

    const handleFilterSubmit = async () => {
        if (!filterStartDate && !filterEndDate && !filterPaymentType && !selectedCustomer) {
            Swal.fire("Info", "Enter at least one filter value", "info");
            return;
        }
        setLoading(true);
        try {
            const payload = {
                start_date: filterStartDate || "",
                end_date: filterEndDate || "",
                payment_type: filterPaymentType || "",
                customer_name: selectedCustomer?.value || "",
                bill_type: filterIncludeBillType ? subTab : "",
                mode: filterIncludeMode ? mainTab : "",
                branch: sessionStorage.getItem("branch") || "",
            };
            const res = await axios.post(`${globalValue}/payment_log_filter`, payload);
            if (res.data && res.data.status) {
                setFilterResult(res.data);
                setShowFilterModal(true);
            } else {
                setFilterResult(null);
                Swal.fire("Warning", "No data found for given filters", "warning");
            }
        } catch (e) {
            Swal.fire("Error", "Unable to fetch filtered data", "error");
        } finally {
            setLoading(false);
        }
    };

    const handleFilterDownloadPDF = () => {
        if (!filterResult || !Array.isArray(filterResult.data)) return;

        const doc = new jsPDF();
        const formatCurrencyPDF = (amount) => {
            const num = typeof amount === "number" ? amount : parseFloat(amount);
            if (isNaN(num)) return "Rs. 0.00";
            return "Rs. " + num.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        };

        doc.setFontSize(18);
        doc.setTextColor(40);
        doc.text("Payment Log Filter Report", 14, 15);

        doc.setFontSize(10);
        doc.setTextColor(100);
        doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 14, 22);
        doc.setDrawColor(200);
        doc.line(14, 25, 196, 25);

        doc.setFontSize(11);
        doc.setTextColor(0);
        doc.text("Filter Criteria:", 14, 32);
        doc.setFontSize(10);
        doc.setTextColor(80);

        let startX = 14;
        const y1 = 38;
        const y2 = 44;
        const gap = 6;

        const printText = (text) => {
            doc.text(text, startX, y1);
            startX += doc.getTextWidth(text) + gap;
        };

        if (filterStartDate) printText(`Start Date: ${filterStartDate}`);
        if (filterEndDate) printText(`End Date: ${filterEndDate}`);
        if (selectedCustomer) printText(`Customer: ${selectedCustomer.label}`);
        printText(`Payment Type: ${filterPaymentType || "All"}`);

        startX = 14;
        if (filterIncludeBillType) {
            const text = `Bill Type: ${subTab}`;
            doc.text(text, startX, y2);
            startX += doc.getTextWidth(text) + gap;
        }
        doc.text(`Mode: ${filterIncludeMode ? mainTab : "All"}`, startX, y2);

        const headers = [["S.No", "Date", "Invoice No", "Customer", "Mode", "Bill Type", "Amount", "Discount"]];
        const rows = filterResult.data.map((item) => [
            item.sno,
            new Date(item.payment_date).toLocaleDateString(),
            item.bill_no,
            item.customer_name,
            item.mode,
            item.bill_type,
            formatCurrencyPDF(item.amount),
            formatCurrencyPDF(item.discount),
        ]);

        autoTable(doc, {
            head: headers,
            body: rows,
            startY: 50,
            styles: { fontSize: 9, cellPadding: 3 },
            headStyles: { fillColor: [41, 128, 185], textColor: 255, fontStyle: "bold", halign: "center" },
            columnStyles: {
                0: { halign: "center" }, 1: { halign: "center" }, 2: { halign: "center" },
                3: { halign: "left" }, 4: { halign: "center" }, 5: { halign: "center" },
                6: { halign: "right" }, 7: { halign: "right" },
            },
            alternateRowStyles: { fillColor: [245, 245, 245] },
            foot: [[
                { content: "Grand Totals", colSpan: 6, styles: { halign: "right", fontStyle: "bold" } },
                { content: formatCurrencyPDF(filterResult.grand_total_amount), styles: { halign: "right", fontStyle: "bold" } },
                { content: formatCurrencyPDF(filterResult.grand_total_discount), styles: { halign: "right", fontStyle: "bold" } },
            ]],
            footStyles: { fillColor: [230, 230, 230], textColor: 0 },
            showFoot: "lastPage",
        });

        doc.save("Payment_Log_Report.pdf");
    };

    // ── Pending Report helpers ─────────────────────────────────────────────────
    const getPendingData = () => {
        let allRows = [];

        // Shared with Filter Report: filterIncludeMode / filterIncludeBillType
        // If unchecked → include ALL modes / tabs; if checked → restrict to current tab
        const modes = filterIncludeMode ? [mainTab] : ['sales', 'service'];
        const tabs  = filterIncludeBillType ? [subTab] : ['cash', 'credit'];

        modes.forEach((mode) => {
            tabs.forEach((tab) => {
                const rows = (data?.[mode]?.[tab] || []).map(r => ({ ...r, _mode: mode, _tab: tab }));
                allRows.push(...rows);
            });
        });

        // Only pending rows
        allRows = allRows.filter(r => (r.pending || 0) > 0);

        // Shared date range filter (bill date) — same inputs as Filter Report
        if (filterStartDate) {
            allRows = allRows.filter(r => new Date(r.date) >= new Date(filterStartDate));
        }
        if (filterEndDate) {
            const end = new Date(filterEndDate);
            end.setHours(23, 59, 59, 999);
            allRows = allRows.filter(r => new Date(r.date) <= end);
        }

        // Customer filter
        if (selectedCustomer && selectedCustomer.value !== "") {
            allRows = allRows.filter(r => r.customer_name === selectedCustomer.value);
        }

        return allRows.sort((a, b) => new Date(b.date) - new Date(a.date));
    };

    const handleShowPendingReport = () => {
        const rows = getPendingData();
        if (rows.length === 0) {
            Swal.fire("Info", "No pending records found for the selected filters.", "info");
            return;
        }
        setPendingReportData(rows);
        setShowPendingModal(true);
    };

    const handlePendingDownloadPDF = () => {
        const rows = pendingReportData;
        if (rows.length === 0) {
            Swal.fire("Info", "No pending records to download.", "info");
            return;
        }

        const doc = new jsPDF({ orientation: "landscape" });

        const formatCurrencyPDF = (amount) => {
            const num = parseFloat(amount);
            if (isNaN(num)) return "Rs. 0.00";
            return "Rs. " + num.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        };

        doc.setFontSize(18);
        doc.setTextColor(180, 0, 0);
        doc.text("Pending Payments Report", 14, 15);

        doc.setFontSize(10);
        doc.setTextColor(100);
        doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 14, 22);
        doc.setDrawColor(200);
        doc.line(14, 25, 283, 25);

        doc.setFontSize(10);
        doc.setTextColor(0);
        const criteriaItems = [];
        if (filterStartDate) criteriaItems.push(`Start Date: ${filterStartDate}`);
        if (filterEndDate)   criteriaItems.push(`End Date: ${filterEndDate}`);
        if (selectedCustomer) criteriaItems.push(`Customer: ${selectedCustomer.label}`);
        criteriaItems.push(`Mode: ${filterIncludeMode ? mainTab : "All"}`);
        criteriaItems.push(`Bill Type: ${filterIncludeBillType ? subTab : "All"}`);
        doc.text("Filter Criteria:  " + criteriaItems.join("   |   "), 14, 32);

        const headers = [["S.No", "Invoice No", "Mode", "Bill Type", "Vehicle No", "Customer Name", "Pending Amount", "Bill Date"]];

        const bodyRows = rows.map((r, i) => [
            i + 1,
            r.bill_no,
            r._mode,
            r._tab,
            r.vehicle_no || "-",
            r.customer_name,
            formatCurrencyPDF(r.pending),
            new Date(r.date).toLocaleDateString(),
        ]);

        const grandPending = rows.reduce((s, r) => s + (parseFloat(r.pending) || 0), 0);

        autoTable(doc, {
            head: headers,
            body: bodyRows,
            startY: 38,
            styles: { fontSize: 8, cellPadding: 2.5 },
            headStyles: { fillColor: [180, 0, 0], textColor: 255, fontStyle: "bold", halign: "center" },
            columnStyles: {
                0: { halign: "center" },
                1: { halign: "center" },
                2: { halign: "center" },
                3: { halign: "center" },
                4: { halign: "center" },
                5: { halign: "left" },
                6: { halign: "right", textColor: [180, 0, 0], fontStyle: "bold" },
                7: { halign: "center" },
            },
            alternateRowStyles: { fillColor: [255, 245, 245] },
            foot: [[
                { content: "Grand Total Pending", colSpan: 6, styles: { halign: "right", fontStyle: "bold" } },
                { content: formatCurrencyPDF(grandPending), styles: { halign: "right", fontStyle: "bold", textColor: [180, 0, 0] } },
                { content: "", styles: {} },
            ]],
            footStyles: { fillColor: [230, 230, 230], textColor: 0 },
            showFoot: "lastPage",
        });

        doc.save("Pending_Payments_Report.pdf");
    };
    // ──────────────────────────────────────────────────────────────────────────

    return (
        <>
            {loading && (
                <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-75 z-50 transition-opacity duration-300">
                    <img src={engineGif} alt="Loading..." className="w-28 h-28" />
                </div>
            )}

            <div
                className={`md:ml-[250px] w-full md:w-[calc(100%-250px)] mt-16 h-[92vh] flex justify-center items-center box-border ${theme === "dark" ? "bg-gray-950 text-white" : "bg-gray-50 text-gray-800"}`}
            >
                <div
                    className={`w-[95%] md:w-[98%] h-[95%] px-4 py-2 rounded-xl shadow-xl overflow-auto ${theme === "dark" ? "bg-gray-800 text-gray-200" : "bg-white text-gray-800"}`}
                >
                    <Head_data data="Manage Payment" font="" size="3xl" color={theme === "dark" ? "text-gray-200" : "text-gray-800"} />

                    {/* Main Tabs */}
                    <div className="flex border-b border-gray-200 dark:border-gray-700 mb-4">
                        <button
                            onClick={() => { setMainTab('sales'); setSubTab('cash'); }}
                            className={`py-2 px-4 text-lg font-medium focus:outline-none transition-colors duration-200 ${mainTab === 'sales' ? 'text-indigo-600 border-b-2 border-indigo-600 dark:text-indigo-400 dark:border-indigo-400' : 'text-gray-600 hover:text-indigo-600 dark:text-gray-400 dark:hover:text-indigo-400'}`}
                        >
                            Sales
                        </button>
                        <button
                            onClick={() => { setMainTab('service'); setSubTab('cash'); }}
                            className={`py-2 px-4 text-lg font-medium focus:outline-none transition-colors duration-200 ${mainTab === 'service' ? 'text-indigo-600 border-b-2 border-indigo-600 dark:text-indigo-400 dark:border-indigo-400' : 'text-gray-600 hover:text-indigo-600 dark:text-gray-400 dark:hover:text-indigo-400'}`}
                        >
                            Service
                        </button>
                    </div>

                    {/* Sub Tabs */}
                    <div className="flex gap-2 mb-4 p-1 rounded-lg bg-gray-100 dark:bg-gray-700 inline-flex">
                        <button
                            onClick={() => setSubTab('cash')}
                            className={`py-2 px-4 text-base rounded-md font-medium focus:outline-none transition-colors duration-200 ${subTab === 'cash' ? 'bg-indigo-600 text-white shadow-md' : 'text-gray-700 hover:bg-gray-200 dark:text-gray-200 dark:hover:bg-gray-600'}`}
                        >
                            Cash Payments
                        </button>
                        <button
                            onClick={() => setSubTab('credit')}
                            className={`py-2 px-4 text-base rounded-md font-medium focus:outline-none transition-colors duration-200 ${subTab === 'credit' ? 'bg-indigo-600 text-white shadow-md' : 'text-gray-700 hover:bg-gray-200 dark:text-gray-200 dark:hover:bg-gray-600'}`}
                        >
                            Credit Payments
                        </button>
                    </div>

                    <div className="flex flex-col gap-4 mb-4">

                        {/* Search and Download Row */}
                        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
                            <TextInput
                                placeholder="Search by Customer Name or Invoice No..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="w-full md:w-1/3"
                            />
                            <button
                                onClick={handleDownloadTablePDF}
                                className="px-4 py-2 bg-green-600 text-white rounded-lg shadow hover:bg-green-700 w-full md:w-auto"
                            >
                                Download PDF
                            </button>
                        </div>

                        {/* Payment Log Filter Row */}
                        <div className="flex flex-wrap items-start gap-4 p-4 bg-gray-50 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
                            <div className="w-full sm:w-64">
                                <Select
                                    options={customerOptions}
                                    value={selectedCustomer}
                                    onChange={setSelectedCustomer}
                                    placeholder="Select Customer"
                                    className="text-sm"
                                    isClearable
                                />
                            </div>
                            <input
                                type="date"
                                value={filterStartDate}
                                onChange={(e) => setFilterStartDate(e.target.value)}
                                className="border border-gray-300 rounded px-2 py-2 text-sm w-full sm:w-auto dark:bg-gray-700 dark:text-white"
                            />
                            <input
                                type="date"
                                value={filterEndDate}
                                onChange={(e) => setFilterEndDate(e.target.value)}
                                className="border border-gray-300 rounded px-2 py-2 text-sm w-full sm:w-auto dark:bg-gray-700 dark:text-white"
                            />
                            <select
                                value={filterPaymentType}
                                onChange={(e) => setFilterPaymentType(e.target.value)}
                                className="border border-gray-300 rounded px-2 py-2 text-sm w-full sm:w-auto dark:bg-gray-700 dark:text-white"
                            >
                                <option value="">Payment Type</option>
                                <option value="cash">Cash</option>
                                <option value="cheque">Cheque</option>
                                <option value="G pay">G Pay</option>
                                <option value="online Transaction">Online Transaction</option>
                            </select>

                            {/* ── Shared checkboxes — apply to both Filter Report & Pending Filter ── */}
                            <div className="flex flex-col justify-center gap-1 min-w-max">
                                <p className="text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-1">Filter Options</p>
                                <label className="flex items-center space-x-2 text-sm cursor-pointer select-none">
                                    <input
                                        type="checkbox"
                                        checked={filterIncludeMode}
                                        onChange={(e) => setFilterIncludeMode(e.target.checked)}
                                        className="rounded text-indigo-600 focus:ring-indigo-500 border-gray-300 dark:border-gray-600 dark:bg-gray-700 w-4 h-4"
                                    />
                                    <span className="text-gray-700 dark:text-gray-300 whitespace-nowrap">Filter by main tab</span>
                                </label>
                                <label className="flex items-center space-x-2 text-sm cursor-pointer select-none">
                                    <input
                                        type="checkbox"
                                        checked={filterIncludeBillType}
                                        onChange={(e) => setFilterIncludeBillType(e.target.checked)}
                                        className="rounded text-indigo-600 focus:ring-indigo-500 border-gray-300 dark:border-gray-600 dark:bg-gray-700 w-4 h-4"
                                    />
                                    <span className="text-gray-700 dark:text-gray-300 whitespace-nowrap">Filter by sub tab</span>
                                </label>
                            </div>

                            <div className="flex gap-2 ml-auto sm:ml-0 items-end">
                                <button
                                    onClick={handleFilterSubmit}
                                    className="px-6 py-2 bg-blue-600 text-white rounded-lg shadow hover:bg-blue-700 w-full sm:w-auto"
                                >
                                    Filter
                                </button>
                                <button
                                    onClick={handleShowPendingReport}
                                    className="px-6 py-2 bg-red-600 text-white rounded-lg shadow hover:bg-red-700 w-full sm:w-auto font-semibold"
                                >
                                    Pending Filter
                                </button>
                            </div>
                        </div>
                    </div>

                    {renderDataTable()}
                </div>
            </div>

            {/* ── Pay Modal ───────────────────────────────────────────────────────── */}
            {selectedRow && (
                <Modal show={isModalOpen} onClose={handleCloseModal} size="2xl" popup className="dark:bg-opacity-70">
                    <Modal.Header className="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
                        <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
                            Process Payment for Invoice No: {selectedRow.bill_no}
                        </h3>
                    </Modal.Header>
                    <Modal.Body className="p-6">
                        <div className="space-y-6">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm text-gray-700 dark:text-gray-300">
                                <p>
                                    <span className="font-semibold text-gray-900 dark:text-white">Customer:</span>{" "}
                                    {selectedRow.customer_name}
                                </p>
                                <p>
                                    <span className="font-semibold text-gray-900 dark:text-white">Date:</span>{" "}
                                    {sessionStorage.getItem("position") === "superadmin" ? (
                                        <input type="date" value={date} onChange={(e) => setDate(e.target.value)} className="border border-gray-300 rounded px-2 py-1" />
                                    ) : (
                                        new Date(date).toLocaleDateString()
                                    )}
                                </p>
                                <p>
                                    <span className="font-semibold text-gray-900 dark:text-white">Total Amount:</span>{" "}
                                    {formatCurrency(selectedRow.amount)}
                                </p>
                                <p>
                                    <span className="font-semibold text-gray-900 dark:text-white">Amount Paid:</span>{" "}
                                    {formatCurrency(selectedRow.paid - paydiscount)}
                                </p>
                                <p>
                                    <span className="font-semibold text-gray-900 dark:text-white">Pending Amount:</span>{" "}
                                    {formatCurrency(selectedRow.pending)}
                                </p>
                                <p>
                                    <span className="font-semibold text-gray-900 dark:text-white">Total Discount Given:</span>{" "}
                                    {formatCurrency(selectedRow.total_discount)}
                                </p>
                            </div>

                            <div className="space-y-2">
                                <Label htmlFor="payment-amount" value="Enter Amount to Pay" className="font-semibold text-gray-900 dark:text-white" />
                                <TextInput
                                    id="payment-amount"
                                    type="number"
                                    placeholder={`Enter amount (max ${formatCurrency(selectedRow.pending)})`}
                                    value={paymentAmount}
                                    onChange={(e) => { setPaymentAmount(e.target.value); setPaymentError(""); }}
                                    onBlur={(e) => {
                                        const val = parseFloat(e.target.value) || 0;
                                        const discountVal = parseFloat(discount) || 0;
                                        if (val <= 0) {
                                            setPaymentError("Please enter a valid amount.");
                                        } else if (val + discountVal > selectedRow.pending) {
                                            setPaymentError(`Amount + Discount cannot exceed ${formatCurrency(selectedRow.pending)}.`);
                                        }
                                    }}
                                    required
                                    color={paymentError ? "failure" : "default"}
                                    helperText={paymentError && <span className="text-red-600 text-sm">{paymentError}</span>}
                                    className="focus:ring-indigo-500 focus:border-indigo-500"
                                />
                            </div>

                            <div className="space-y-2">
                                <Label htmlFor="discount" value="Enter Discount" className="font-semibold text-gray-900 dark:text-white" />
                                <TextInput
                                    id="discount"
                                    type="number"
                                    placeholder="Enter discount"
                                    value={discount}
                                    onChange={(e) => { setDiscount(e.target.value); setPaymentError1(""); }}
                                    onBlur={(e) => {
                                        const discountVal = parseFloat(e.target.value) || 0;
                                        const paymentVal = parseFloat(paymentAmount) || 0;
                                        if (discountVal < 0) {
                                            setPaymentError1("Discount cannot be negative.");
                                        } else if (paymentVal + discountVal > selectedRow.pending) {
                                            setPaymentError1(`Amount + Discount cannot exceed ${formatCurrency(selectedRow.pending)}.`);
                                        }
                                    }}
                                    color={paymentError1 ? "failure" : "default"}
                                    helperText={paymentError1 && <span className="text-red-600 text-sm">{paymentError1}</span>}
                                    className="focus:ring-indigo-500 focus:border-indigo-500"
                                />
                            </div>

                            <div className="space-y-2">
                                <Label htmlFor="payment-type" value="Enter Payment Type" className="font-semibold text-gray-900 dark:text-white" />
                                <select
                                    id="payment-type"
                                    onChange={(e) => setPaymentType(e.target.value)}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                                >
                                    <option value="">Select payment Type</option>
                                    <option value="cash">Cash</option>
                                    <option value="cheque">Cheque</option>
                                    <option value="G pay">G Pay</option>
                                    <option value="online Transaction">Online Transaction</option>
                                </select>
                            </div>

                            {mainTab === "service" && (
                                <div className="space-y-2">
                                    <Label htmlFor="payment-from" value="Enter Payment From" className="font-semibold text-gray-900 dark:text-white" />
                                    <select
                                        id="payment-from"
                                        onChange={(e) => setPayment_from(e.target.value)}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                                    >
                                        <option value="">Select payment from</option>
                                        <option value="Insurance">Insurance</option>
                                        <option value="Customer">Customer</option>
                                    </select>
                                </div>
                            )}
                        </div>
                    </Modal.Body>

                    <Modal.Footer className="flex justify-end p-6 border-t border-gray-200 dark:border-gray-700">
                        <button
                            onClick={handlePaymentSubmit}
                            className="px-5 py-2.5 rounded-lg font-semibold bg-indigo-600 text-white hover:bg-indigo-700 focus:outline-none focus:ring-4 focus:ring-indigo-300 dark:focus:ring-indigo-800 transition duration-200 ease-in-out"
                        >
                            Submit Payment
                        </button>
                        <button
                            onClick={handleCloseModal}
                            className="ml-3 px-5 py-2.5 rounded-lg font-semibold bg-gray-200 text-gray-800 hover:bg-gray-300 dark:bg-gray-700 dark:text-gray-200 dark:hover:bg-gray-600 focus:outline-none focus:ring-4 focus:ring-gray-300 dark:focus:ring-gray-700 transition duration-200 ease-in-out"
                        >
                            Cancel
                        </button>
                    </Modal.Footer>
                </Modal>
            )}

            {/* ── Log Modal ───────────────────────────────────────────────────────── */}
            <Modal show={isLogModalOpen} onClose={() => {
                setIsLogModalOpen(false);
                setEditingIndex(null);
                setEditForm({ id: "", amount: "", discount: "" });
                fetchData();
            }} size="2xl" popup>
                <Modal.Header>
                    <div className="flex justify-between items-center w-full">
                        <h3 className="text-lg font-semibold text-gray-800 dark:text-white">
                            Payment Logs for Invoice No: {selectedLogBillNo}
                        </h3>
                        {logData.length > 0 && (
                            <button onClick={handleDownloadPDF} className="bg-red-500 ms-4 hover:bg-red-600 text-white text-sm px-3 py-1 rounded">
                                Download PDF
                            </button>
                        )}
                    </div>
                </Modal.Header>

                <Modal.Body>
                    {logData.length > 0 ? (
                        <>
                            <table className="min-w-full text-sm text-left text-gray-700 dark:text-gray-300">
                                <thead className="bg-gray-100 dark:bg-gray-700">
                                    <tr>
                                        <th className="py-2 px-4">#</th>
                                        <th className="py-2 px-4">Date</th>
                                        <th className="py-2 px-4">Amount</th>
                                        <th className="py-2 px-4">Type</th>
                                        <th className="py-2 px-4">Discount</th>
                                        {mainTab === "service" && <th className="py-2 px-4">From</th>}
                                        <th className="py-2 px-4 text-center">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {(() => {
                                        const sortedData = [...logData].sort((a, b) => new Date(b[1]) - new Date(a[1]));
                                        return sortedData.map((log, index) => (
                                            <tr key={log.id || index} className="border-b border-gray-200 dark:border-gray-600">
                                                <td className="py-2 px-4">{index + 1}</td>
                                                <td className="py-2 px-4">{log[1]}</td>
                                                <td className="py-2 px-4">{formatCurrency(log[2])}</td>
                                                <td className="py-2 px-4">{log[3]}</td>
                                                <td className="py-2 px-4">{formatCurrency(log[5])}</td>
                                                {mainTab === "service" && <td className="py-2 px-4">{log[4]}</td>}
                                                <td className="py-2 px-4 text-center">
                                                    {log[3] !== "refund" && (
                                                        <button onClick={() => handleEditClick(log, index)} className="text-blue-600 hover:text-blue-800">
                                                            <PencilSquareIcon className="h-5 w-5 inline" />
                                                        </button>
                                                    )}
                                                </td>
                                            </tr>
                                        ));
                                    })()}
                                </tbody>
                            </table>

                            {editingIndex !== null && (
                                <div className="mt-5 p-4 bg-gray-50 dark:bg-gray-800 rounded-lg border dark:border-gray-700">
                                    <h4 className="font-semibold mb-3 text-gray-800 dark:text-gray-200">
                                        Edit Entry #{editForm.id}
                                    </h4>
                                    <div className="flex flex-col sm:flex-row gap-4 items-center">
                                        <div className="flex flex-col w-full sm:w-1/3">
                                            <label className="text-xs text-gray-500 mb-1">Amount</label>
                                            <input
                                                type="number"
                                                value={editForm.amount}
                                                onChange={(e) => onChangeAmount(e.target.value)}
                                                className="border rounded px-3 py-2 w-full text-sm dark:bg-gray-700 dark:text-white"
                                            />
                                        </div>
                                        <div className="flex flex-col w-full sm:w-1/3">
                                            <label className="text-xs text-gray-500 mb-1">Discount</label>
                                            <input
                                                type="number"
                                                value={editForm.discount}
                                                onChange={(e) => onChangeDiscount(e.target.value)}
                                                className="border rounded px-3 py-2 w-full text-sm dark:bg-gray-700 dark:text-white"
                                            />
                                        </div>
                                        <button onClick={handleUpdate} className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded text-sm">
                                            Update
                                        </button>
                                    </div>
                                </div>
                            )}

                            {(() => {
                                const totalAmount = logData.reduce((acc, log) => acc + (parseFloat(log[2]) || 0), 0);
                                const totalDiscount = logData.reduce((acc, log) => acc + (parseFloat(log[5]) || 0), 0);
                                const originalAmount = totalAmount + totalDiscount;
                                return (
                                    <div className="mt-4 flex flex-col sm:flex-row justify-between items-start sm:items-center text-sm font-semibold gap-2">
                                        <div className="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 px-3 py-1.5 rounded-lg text-yellow-700 dark:text-yellow-400">
                                            Available Advance Balance: {formatCurrency(advanceAmount)}
                                        </div>
                                        <div className="text-right">
                                            <p>Normal Amount Total: {formatCurrency(totalAmount)}</p>
                                            <p>Discount Total: {formatCurrency(totalDiscount)}</p>
                                            <p className="text-blue-600 dark:text-blue-400">Original Amount: {formatCurrency(originalAmount)}</p>
                                        </div>
                                    </div>
                                );
                            })()}
                        </>
                    ) : (
                        <p className="text-center text-sm text-gray-600 dark:text-gray-400">No payment logs found.</p>
                    )}
                </Modal.Body>
            </Modal>

            {/* ── Payment Log Filter Result Modal ─────────────────────────────────── */}
            <Modal show={showFilterModal} onClose={() => { setShowFilterModal(false); setFilterResult(null); }} size="5xl">
                <Modal.Header>Payment Log Report</Modal.Header>
                <Modal.Body className="p-0">
                    {filterResult && Array.isArray(filterResult.data) && filterResult.data.length > 0 ? (
                        <div id="filter-pdf-content" className="flex flex-col h-[70vh]">
                            <div className="bg-gray-50 dark:bg-gray-800 p-4 border-b border-gray-200 dark:border-gray-700">
                                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                                    <div className="bg-white dark:bg-gray-700 p-3 rounded-lg shadow-sm border border-gray-200 dark:border-gray-600">
                                        <p className="text-xs text-gray-500 dark:text-gray-400 uppercase font-bold tracking-wider">Date Range</p>
                                        <p className="font-medium text-gray-800 dark:text-gray-200 mt-1">
                                            {filterStartDate ? new Date(filterStartDate).toLocaleDateString() : 'Start'}
                                            <span className="mx-2 text-gray-400">→</span>
                                            {filterEndDate ? new Date(filterEndDate).toLocaleDateString() : 'End'}
                                        </p>
                                    </div>
                                    <div className="bg-white dark:bg-gray-700 p-3 rounded-lg shadow-sm border border-gray-200 dark:border-gray-600">
                                        <p className="text-xs text-gray-500 dark:text-gray-400 uppercase font-bold tracking-wider">Filters</p>
                                        <div className="flex gap-2 mt-1">
                                            <span className="px-2 py-0.5 bg-blue-100 text-blue-800 rounded text-xs font-semibold capitalize">{filterPaymentType || 'All Types'}</span>
                                            <span className="px-2 py-0.5 bg-purple-100 text-purple-800 rounded text-xs font-semibold capitalize">{filterIncludeBillType ? subTab + " Bill Type" : 'All Bill Types'}</span>
                                            <span className="px-2 py-0.5 bg-green-100 text-green-800 rounded text-xs font-semibold capitalize">{filterIncludeMode ? mainTab : 'All Modes'}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="flex-1 overflow-auto relative">
                                <table className="min-w-full text-sm text-left text-gray-700 dark:text-gray-300 border-collapse">
                                    <thead className="bg-gray-100 dark:bg-gray-700 sticky top-0 z-20 shadow-sm">
                                        <tr>
                                            <th className="py-3 px-4 font-semibold bg-gray-100 dark:bg-gray-700 border-b border-gray-200 dark:border-gray-600">S.No</th>
                                            <th className="py-3 px-4 font-semibold bg-gray-100 dark:bg-gray-700 border-b border-gray-200 dark:border-gray-600">Invoice No</th>
                                            <th className="py-3 px-4 font-semibold bg-gray-100 dark:bg-gray-700 border-b border-gray-200 dark:border-gray-600">Mode</th>
                                            <th className="py-3 px-4 font-semibold bg-gray-100 dark:bg-gray-700 border-b border-gray-200 dark:border-gray-600">Bill Type</th>
                                            <th className="py-3 px-4 font-semibold bg-gray-100 dark:bg-gray-700 border-b border-gray-200 dark:border-gray-600">Customer</th>
                                            <th className="py-3 px-4 font-semibold text-right bg-gray-100 dark:bg-gray-700 border-b border-gray-200 dark:border-gray-600">Amount</th>
                                            <th className="py-3 px-4 font-semibold text-right bg-gray-100 dark:bg-gray-700 border-b border-gray-200 dark:border-gray-600">Discount</th>
                                            <th className="py-3 px-4 font-semibold bg-gray-100 dark:bg-gray-700 border-b border-gray-200 dark:border-gray-600">Date</th>
                                        </tr>
                                    </thead>
                                    <tbody className="divide-y divide-gray-200 dark:divide-gray-700 bg-white dark:bg-gray-800">
                                        {filterResult.data.map((item) => (
                                            <tr key={item.payment_detail_id || item.sno} className="hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors">
                                                <td className="py-3 px-4 font-medium text-gray-500">{item.sno}</td>
                                                <td className="py-3 px-4 font-medium">{item.bill_no}</td>
                                                <td className="py-3 px-4 capitalize">
                                                    <span className={`px-2 py-1 rounded-full text-xs ${item.mode === 'sales' ? 'bg-green-100 text-green-800' : 'bg-orange-100 text-orange-800'}`}>
                                                        {item.mode}
                                                    </span>
                                                </td>
                                                <td className="py-3 px-4 capitalize text-gray-600 dark:text-gray-400">{item.bill_type}</td>
                                                <td className="py-3 px-4 font-medium text-gray-900 dark:text-white">{item.customer_name}</td>
                                                <td className="py-3 px-4 text-right font-mono text-gray-700 dark:text-gray-300">{formatCurrency(item.amount)}</td>
                                                <td className="py-3 px-4 text-right font-mono text-red-600">{formatCurrency(item.discount)}</td>
                                                <td className="py-3 px-4 text-gray-500">{new Date(item.payment_date).toLocaleDateString()}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot className="bg-gray-100 dark:bg-gray-700 font-bold sticky bottom-0 shadow-[0_-2px_4px_rgba(0,0,0,0.1)]">
                                        <tr>
                                            <td colSpan="5" className="py-3 px-4 text-right text-gray-600 dark:text-gray-400 uppercase text-xs tracking-wider">Grand Totals</td>
                                            <td className="py-3 px-4 text-right text-gray-900 dark:text-white">{formatCurrency(filterResult.grand_total_amount)}</td>
                                            <td className="py-3 px-4 text-right text-red-600">{formatCurrency(filterResult.grand_total_discount)}</td>
                                            <td className="py-3 px-4"></td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    ) : (
                        <div className="flex flex-col items-center justify-center h-64 text-gray-500">
                            <p className="text-lg">No records found matching your criteria.</p>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <button onClick={handleFilterDownloadPDF} className="px-4 py-2 bg-red-600 text-white rounded">Download</button>
                    <button onClick={() => setShowFilterModal(false)} className="px-4 py-2 bg-gray-300 rounded">Close</button>
                </Modal.Footer>
            </Modal>

            {/* ── Pending Report Modal ─────────────────────────────────────────────── */}
            <Modal show={showPendingModal} onClose={() => { setShowPendingModal(false); setPendingReportData([]); }} size="7xl">
                <Modal.Header>
                    <span className="text-red-700 font-bold">⚠️ Pending Payments Report</span>
                </Modal.Header>
                <Modal.Body className="p-0">
                    {pendingReportData.length > 0 ? (
                        <div className="flex flex-col h-[70vh]">

                            {/* Summary Header */}
                            <div className="bg-red-50 dark:bg-gray-800 p-4 border-b border-red-200 dark:border-red-900">
                                <div className="grid grid-cols-1 md:grid-cols-4 gap-4">

                                    <div className="bg-white dark:bg-gray-700 p-3 rounded-lg shadow-sm border border-red-100 dark:border-red-800">
                                        <p className="text-xs text-gray-500 dark:text-gray-400 uppercase font-bold tracking-wider">Date Range</p>
                                        <p className="font-medium text-gray-800 dark:text-gray-200 mt-1">
                                            {filterStartDate ? new Date(filterStartDate).toLocaleDateString() : 'All'}
                                            <span className="mx-2 text-gray-400">→</span>
                                            {filterEndDate ? new Date(filterEndDate).toLocaleDateString() : 'All'}
                                        </p>
                                    </div>

                                    <div className="bg-white dark:bg-gray-700 p-3 rounded-lg shadow-sm border border-red-100 dark:border-red-800">
                                        <p className="text-xs text-gray-500 dark:text-gray-400 uppercase font-bold tracking-wider">Filters Applied</p>
                                        <div className="flex flex-wrap gap-2 mt-1">
                                            <span className="px-2 py-0.5 bg-red-100 text-red-800 rounded text-xs font-semibold capitalize">
                                                {filterIncludeMode ? mainTab : 'All Modes'}
                                            </span>
                                            <span className="px-2 py-0.5 bg-orange-100 text-orange-800 rounded text-xs font-semibold capitalize">
                                                {filterIncludeBillType ? subTab + " Bill" : 'All Bill Types'}
                                            </span>
                                        </div>
                                    </div>

                                    <div className="bg-white dark:bg-gray-700 p-3 rounded-lg shadow-sm border border-red-100 dark:border-red-800">
                                        <p className="text-xs text-gray-500 dark:text-gray-400 uppercase font-bold tracking-wider">Total Records</p>
                                        <p className="text-2xl font-bold text-gray-800 dark:text-gray-100 mt-1">{pendingReportData.length}</p>
                                    </div>

                                    <div className="bg-red-600 p-3 rounded-lg shadow-sm">
                                        <p className="text-xs text-red-100 uppercase font-bold tracking-wider">Total Pending</p>
                                        <p className="text-2xl font-bold text-white mt-1">
                                            {formatCurrency(pendingReportData.reduce((s, r) => s + (parseFloat(r.pending) || 0), 0))}
                                        </p>
                                    </div>

                                </div>
                            </div>

                            {/* Table */}
                            <div className="flex-1 overflow-auto relative">
                                <table className="min-w-full text-sm text-left text-gray-700 dark:text-gray-300 border-collapse">
                                    <thead className="bg-gray-100 dark:bg-gray-700 sticky top-0 z-20 shadow-sm">
                                        <tr>
                                            <th className="py-3 px-4 font-semibold border-b border-gray-200 dark:border-gray-600">S.No</th>
                                            <th className="py-3 px-4 font-semibold border-b border-gray-200 dark:border-gray-600">Invoice No</th>
                                            <th className="py-3 px-4 font-semibold border-b border-gray-200 dark:border-gray-600">Mode</th>
                                            <th className="py-3 px-4 font-semibold border-b border-gray-200 dark:border-gray-600">Bill Type</th>
                                            <th className="py-3 px-4 font-semibold border-b border-gray-200 dark:border-gray-600">Vehicle No</th>
                                            <th className="py-3 px-4 font-semibold border-b border-gray-200 dark:border-gray-600">Customer Name</th>
                                            <th className="py-3 px-4 font-semibold text-right border-b border-gray-200 dark:border-gray-600 text-red-600">Pending</th>
                                            <th className="py-3 px-4 font-semibold border-b border-gray-200 dark:border-gray-600">Bill Date</th>
                                        </tr>
                                    </thead>
                                    <tbody className="divide-y divide-gray-200 dark:divide-gray-700 bg-white dark:bg-gray-800">
                                        {pendingReportData.map((row, index) => (
                                            <tr key={row.id || index} className="hover:bg-red-50 dark:hover:bg-gray-700 transition-colors">
                                                <td className="py-3 px-4 text-gray-500">{index + 1}</td>
                                                <td className="py-3 px-4 font-medium">{row.bill_no}</td>
                                                <td className="py-3 px-4 capitalize">
                                                    <span className={`px-2 py-1 rounded-full text-xs font-semibold ${row._mode === 'sales' ? 'bg-green-100 text-green-800' : 'bg-orange-100 text-orange-800'}`}>
                                                        {row._mode}
                                                    </span>
                                                </td>
                                                <td className="py-3 px-4 capitalize text-gray-600 dark:text-gray-400">{row._tab}</td>
                                                <td className="py-3 px-4 text-gray-600">{row.vehicle_no || "-"}</td>
                                                <td className="py-3 px-4 font-medium text-gray-900 dark:text-white">{row.customer_name}</td>
                                                <td className="py-3 px-4 text-right font-mono font-bold text-red-600">{formatCurrency(row.pending)}</td>
                                                <td className="py-3 px-4 text-gray-500">{new Date(row.date).toLocaleDateString()}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot className="bg-gray-100 dark:bg-gray-700 font-bold sticky bottom-0 shadow-[0_-2px_4px_rgba(0,0,0,0.1)]">
                                        <tr>
                                            <td colSpan="6" className="py-3 px-4 text-right text-gray-600 dark:text-gray-400 uppercase text-xs tracking-wider">
                                                Grand Total Pending
                                            </td>
                                            <td className="py-3 px-4 text-right font-mono text-red-600">
                                                {formatCurrency(pendingReportData.reduce((s, r) => s + (parseFloat(r.pending) || 0), 0))}
                                            </td>
                                            <td className="py-3 px-4"></td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    ) : (
                        <div className="flex flex-col items-center justify-center h-64 text-gray-500">
                            <p className="text-lg">No pending records found for the selected filters.</p>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <button onClick={handlePendingDownloadPDF} className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 font-semibold">
                        Download PDF
                    </button>
                    <button onClick={() => { setShowPendingModal(false); setPendingReportData([]); }} className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400">
                        Close
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default Payment;